module.exports = __webpack_public_path__ + "static/albino_dwarf-f6591447ab0b3e51ba7968a232e864c6.png";